<template>
    <div class="bg-white rounded-xl shadow-lg p-6">
        <div class="flex items-center justify-between mb-6">
            <h3 class="text-lg font-semibold text-gray-800">Campus Distribution</h3>
        </div>
        <apexchart type="bar" :options="chartOptions" :series="chartSeries" height="300" />
    </div>
</template>

<script>
export default {
    name: "RegionalDistributionChart",
    props: {
        data: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    computed: {
        chartSeries() {
            return [{
                name: 'Graduates',
                data: this.data.map(item => item.count)
            }];
        },
        chartOptions() {
            return {
                chart: {
                    type: 'bar',
                    toolbar: {
                        show: false
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%'
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val;
                    },
                    style: {
                        fontSize: '12px',
                        fontWeight: 'bold'
                    },
                    position: 'center'
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: this.data.map(item => item.campus_code),
                    labels: {
                        style: {
                            fontSize: '12px'
                        }
                    }
                },
                yaxis: {
                    title: {
                        text: 'Number of Graduates'
                    }
                },
                fill: {
                    opacity: 1,
                    type: 'gradient',
                    gradient: {
                        shade: 'light',
                        type: 'vertical',
                        shadeIntensity: 0.25,
                        gradientToColors: undefined,
                        inverseColors: true,
                        opacityFrom: 1,
                        opacityTo: 0.85,
                        stops: [50, 0, 100]
                    }
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + ' graduates';
                        }
                    }
                }
            };
        }
    }
};
</script>

<style scoped>
/* Component-specific styles can be added here */
</style>